import { render, staticRenderFns } from "./AffirmEvents.vue?vue&type=template&id=3f52b984&"
import script from "./AffirmEvents.vue?vue&type=script&lang=js&"
export * from "./AffirmEvents.vue?vue&type=script&lang=js&"
import style0 from "./AffirmEvents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports